import type { CSSProperties } from 'react';

const SWEEP_MAX_MS = 1400;
const FLIP_SCALE = 0.32;

export const sweepVars = (n: number): CSSProperties => {
  const stagger = n > 0 ? Math.min(20, SWEEP_MAX_MS / n) : 0;
  return {
    '--enter-stagger': `${stagger}ms`,
    '--flip-stagger': `${stagger * FLIP_SCALE}ms`,
  } as CSSProperties;
};
